import { render, staticRenderFns } from "./TextFormat.vue?vue&type=template&id=14289c11&"
import script from "./TextFormat.vue?vue&type=script&lang=js&"
export * from "./TextFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports